import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARReturnActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Return/ReturnBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceARReturn"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARReturn"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARReturnActivity)
